module.exports = __webpack_public_path__ + "img/ico_delivery_holiday.722a369.svg";